<template>
  <div id="page-event">
    <div class="main">
      <div class="content-down">

        <div class="tab-header" :class="{'tab-header-stick':isTabHeaderStick}">
          <span
              class="tab-title"
              :class="{'tab-title-selected':isShowQunzu,'disabled':enableQunzu}"
              @click="changeView(0)"
              v-if="this.enable_qun"
          >群组</span>
          <span
              class="tab-title"
              :class="{'tab-title-selected':isShowFayanren,'disabled':enableFayanren}"
              @click="changeView(1)"
              v-if="this.enable_sender"
          >发言人</span>
          <span
              class="tab-title"
              :class="{'tab-title-selected':isShowXiaoxi,'disabled':enableXiaoxi}"
              @click="changeView(2)"
              v-if="this.enable_msg"
          >消息</span>
        </div>

        <div class="tab-main tab-main-qunList" v-show="isShowQunzu && this.enable_qun">
          <div class="tab-middle">
            <Select class="job-select">
              <Option v-for="item in jobNameListQun" :value="item.id" :key="item.id" @click.native="getQunListData(item.id)">{{item.name}}</Option>
            </Select>
          </div>
          <div class="tab-content">
            <Table border :columns="column1" :data="qunList">
              <template #action="{ row, index }">
                <Button type="error" size="small" @click="cancelQunFocue(row.id)">取消关注</Button>
              </template>
            </Table>
          </div>
          <div class="page-wrapper">
            <Page
                :total="listQun_total"
                :current="currentPageQun"
                @on-change="changePageQun"
                show-total
            />
          </div>
        </div>

        <div class="tab-main tab-main-fayanrenList" v-show="isShowFayanren && this.enable_sender">
          <div class="table-middle">
            <Select class="job-select">
              <Option v-for="item in jobNameListFayanren" :value="item.id" :key="item.id" @click="getFayanrenListData(item.id)">{{item.name}}</Option>
            </Select>
          </div>
          <div class="tab-content">
            <Table border :columns="column2" :data="fayanrenList">
              <template #action="{ row, index }">
                <Button type="error" size="small" @click="cancelFayanrenFocue(row.id)">取消关注</Button>
              </template>
            </Table>
          </div>
          <div class="page-wrapper">
            <Page
                :total="listFayanren_total"
                :current="currentPageFayanren"
                @on-change="changePageFayanren"
                show-total
            />
          </div>
        </div>

        <div class="tab-main table-main-msgList" v-show="isShowXiaoxi && this.enable_msg">
          <div class="table-middle">
            <Select class="job-select">
              <Option v-for="item in jobNameListMsg" :value="item.id" :key="item.id" @click="getXiaoxiListData(item.id)">{{item.name}}</Option>
            </Select>
          </div>
          <div class="tab-content">
            <Table border :columns="column3" :data="xiaoxiList">

              <template #action="{ row, index }">
                <Button type="error" size="small" @click="cancelXiaoxiFocue(row.id)">取消关注</Button>
              </template>
            </Table>
          </div>
          <div class="page-wrapper">
            <Page
                :total="listMessage_total"
                :current="currentPageXiaoxi"
                @on-change="changePageXiaoxi"
                show-total
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enable_msg: false,
      enable_qun: false,
      enable_sender: false,
      //tabHeader是否吸顶
      isTabHeaderStick: false,
      isShowQunzu: true,
      isShowFayanren: false,
      isShowXiaoxi: false,
      enableQunzu: true,
      enableFayanren: true,
      enableXiaoxi: true,
      jobNameListQun: [],
      jobNameListFayanren: [],
      jobNameListMsg: [],
      qunList: [],
      fayanrenList: [],
      xiaoxiList: [],
      listQun_total: 0,
      listFayanren_total: 0,
      listMessage_total: 0,
      currentPageQun: 1,
      currentPageFayanren: 1,
      currentPageXiaoxi: 1,
      pageSize: 10,
      queryData: {
        jobId: "",
        qunGroupId: "",
        fayanrenId: "",
        msgId: "",
        type: 0,
        pageNum: 1,
        pageSize: 10,
        qunSearchJobId: "",
        senderSearchJobId: "",
        msgSearchJobId: ""
      },
      column1:[
        {
          title:"序号",
          width: 80,
          key:"xuhao",
          align: 'center'
        },
        {
          title:"所属任务",
          key:"jobNames"
        },
        {
          title:"群类型",
          width: 80,
          key:"groupType",
          align: 'center'
        },
        {
          title:"群名",
          key:"groupName"
        },
        {
          title:"关注时间",
          width: 110,
          key:"focusDate",
          align: 'center'
        },
        {
          title:"操作",
          slot:"action",
          width: 110,
          align: 'center'
        },
      ],
      column2:[
        {
          title:"序号",
          width: 80,
          key:"xuhao",
          align: 'center'
        },
        {
          title:"发言人",
          key:"sendMsgName"
        },
        {
          title:"群类型",
          width: 80,
          key:"groupType",
          align: 'center'
        },
        {
          title:"参与群组量",
          width: 110,
          key:"senderQuns",
          align: 'center'
        },
        {
          title:"所属任务",
          key:"jobNames"
        },
        {
          title:"关注时间",
          width: 110,
          key:"focusDate",
          align: 'center'
        },
        {
          title:"操作",
          slot:"action",
          width: 110,
          align: 'center'
        },
      ],
      column3:[
        {
          title:"所属任务",
          key:"jobNames"
        },
        {
          title:"群名",
          key:"groupName"
        },
        {
          title:"发言人",
          key:"sendMsgName"
        },
        {
          title:"发送时间",
          width: 110,
          key:"publishTime",
          align: 'center'
        },
        {
          title:"内容",
          key:"msg",
          ellipsis: true,
          tooltip: true,
          tooltipTheme:"light",
          tooltipMaxWidth:500
        },
        {
          title:"操作",
          slot:"action",
          width: 110,
          align: 'center'
        },
      ],
    }
  },
  methods: {
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      this.enable_qun = authorites.includes("focus_qun");
      this.enable_sender = authorites.includes("focus_sender");
      this.enable_msg = authorites.includes("focus_msg");
    },
    changeView(param) {
      if (param === 0) {
        if (this.enableQunzu) {
          this.isShowQunzu = true;
          this.isShowFayanren = false;
          this.isShowXiaoxi = false;
          this.queryData.type = 0;
        } else {
          this.$Message.error('未获得查看该模块权限');
        }
      } else if (param === 1) {
        if (this.enableFayanren) {
          this.isShowQunzu = false;
          this.isShowFayanren = true;
          this.isShowXiaoxi = false;
          this.queryData.type = 1;
        } else {
          this.$Message.error('未获得查看该模块权限');
        }
      } else if (param === 2) {
        if (this.enableXiaoxi) {
          this.isShowQunzu = false;
          this.isShowFayanren = false;
          this.isShowXiaoxi = true;
          this.queryData.type = 2;
        } else {
          this.$Message.error('未获得查看该模块权限');
        }
      }
    },

    getQunListData(id) {
      if (id) {
        this.queryData.qunSearchJobId = id;
      }

      this.$ajax({
        method: "get",
        url: "./focusOn/getDataList",
        params: {
          type: 0,
          pageNum: this.queryData.pageNum,
          pageSize: this.queryData.pageSize,
          jobId: this.queryData.qunSearchJobId,
        },
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.qunList = [];
            this.qunList = res.data.data.data;
            this.listQun_total = res.data.data.count;
          }
        }
      })
      .catch(err => {
        this.$Message.error(err);
        console.log(err);
      })
    },

    getFayanrenListData(id) {
      if (id) {
        this.queryData.senderSearchJobId = id;
      }

      this.$ajax({
        method: "get",
        url: "./focusOn/getDataList",
        params: {
          type: 1,
          pageNum: this.queryData.pageNum,
          pageSize: this.queryData.pageSize,
          jobId: this.queryData.senderSearchJobId,
        },
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.fayanrenList = [];
            this.fayanrenList = res.data.data.data;
            this.listFayanren_total = res.data.data.total;
          }
        }
      })
      .catch(err => {
        this.$Message.error(err);
        console.log(err);
      })
    },

    getXiaoxiListData(id) {
      if (id) {
        this.queryData.msgSearchJobId = id
      }

      this.$ajax({
        method: "get",
        url: "./focusOn/getDataList",
        params: {
          type: 2,
          pageNum: this.queryData.pageNum,
          pageSize: this.queryData.pageSize,
          jobId: this.queryData.msgSearchJobId,
        },
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.xiaoxiList = [];
            this.xiaoxiList = res.data.data.data;
            this.listMessage_total = res.data.data.total;
          }
        }
      })
      .catch(err => {
        this.$Message.error(err);
        console.log(err);
      })
    },

    getQunJobList() {
      this.$ajax({
        method: "get",
        url: "./focusOn/getAllJobsQun"
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.jobNameListQun = [];
            this.jobNameListQun = res.data.data;
          }
        }
      })
    },

    getFayanrenJobList() {
      this.$ajax({
        method: "get",
        url: "./focusOn/getAllJobsSender"
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.jobNameListFayanren = [];
            this.jobNameListFayanren = res.data.data;
          }
        }
      })
    },

    getXiaoxiJobList() {
      this.$ajax({
        method: "get",
        url: "./focusOn/getAllJobsMsg"
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.jobNameListMsg = [];
            this.jobNameListMsg = res.data.data;
          }
        }
      })
    },

    cancelQunFocue(id) {
      this.$ajax({
        method: "get",
        url: "./focusOn/cancelFocusOn",
        params: {
          type: 0,
          focusIds: id
        },
      }).then(res => {
        if (res.data.success) {
          this.getQunListData()
        }
      })
      .catch(err => {
        console.log(err)
      })
    },

    cancelFayanrenFocue(id) {
      this.$ajax({
        method: "get",
        url: "./focusOn/cancelFocusOn",
        params: {
          type: 1,
          focusIds: id
        },
      })
      .then(res => {
        if (res.data.success) {
          this.getFayanrenListData()
        }
      })
      .catch(err => {
        console.log(err)
      })
    },

    cancelXiaoxiFocue(id) {
      this.$ajax({
        method: "get",
        url: "./focusOn/cancelFocusOn",
        params: {
          type: 2,
          focusIds: id
        },
      })
      .then(res => {
        if (res.data.success) {
          this.getXiaoxiListData()
        }
      })
      .catch(err => {
        console.log(err)
      })
    },

    changePageQun(page) {
      this.queryData.pageNum = page;
      this.getQunListData();
    },

    changePageFayanren(page) {
      this.queryData.pageNum = page;
      this.getFayanrenListData();
    },

    changePageXiaoxi(page) {
      this.queryData.pageNum = page;
      this.getXiaoxiListData();
    },
  },
  created() {
    this.getAuthorities();
    this.getQunListData();
    this.getFayanrenListData();
    this.getXiaoxiListData();
    this.getQunJobList();
    this.getFayanrenJobList();
    this.getXiaoxiJobList();
  },
  mounted() {

  }
}
</script>

<style lang="less">
#page-event {
  .main {
    width: 1160px;
    margin: 20px auto !important;
    background-color: #fff;
    padding: 0 80px;
  }
  .job-select {
    width: 200px;
    margin: 10px 0;
    display: block;
  }
  .content-down {
    background-color: #fff;
    margin-top: 16px;
    padding: 20px 0 50px 0;
    .tab-header {
      height: 59px;
      border-bottom: 1px solid #efeff4;
      position: relative;
      .tab-title {
        float: left;
        width: 75px;
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        margin-right: 64px;
        cursor: pointer;
      }
      .tab-title-selected {
        border-bottom: 3px solid #415af6;
      }
      .dataNum-wrapper {
        position: absolute;
        right: 0;
        padding: 18px 0;
        overflow: hidden;
        height: 100%;
        box-sizing: border-box;
        margin-right: 23px;
        .tag-dataNum {
          float: left;
          margin-left: 20px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    .tab-content {
      .tip {
        margin: 20px 0 10px 0;
        p {
          padding-left: 5px;
          height: 30px;
          line-height: 30px;
          text-align: left;
          background-color: #fffcdd;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffa810;
          cursor: pointer;
        }
        p:hover {
          opacity: 0.8;
        }
      }
      .listQun-wrapper {
        margin-top: 20px;
        .listQun {
          .lisyQun-item {
            overflow: hidden;
            margin-bottom: 10px;
            .ls {
              float: left;
            }
            .rs {
              float: left;
              width: 800px;
              padding-left: 15px;
              .message-title {
                text-align: left;
                .message-link-toSpecGroup {
                  display: inline-block;
                  border-bottom: 2px solid #fff;
                  cursor: pointer;
                  box-sizing: border-box;
                  .groupMemberName {
                    font-family: PingFangSC-Medium;
                    font-size: 16px;
                    color: #415af6;
                    letter-spacing: 0;
                    line-height: 24px;
                  }
                  .groupNum {
                    font-family: PingFangSC-Medium;
                    font-size: 16px;
                    color: #415af6;
                    letter-spacing: 0;
                    line-height: 24px;
                    margin-left: 15px;
                  }
                }
                .message-link-toSpecGroup:hover {
                  box-sizing: border-box;
                  border-bottom: 2px solid #415af6;
                }
              }
              .message-content {
                margin-top: 8px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                text-align: left;
                line-height: 22px;
              }
              .message-footer {
                overflow: hidden;
                .checkContext {
                  float: right;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #415af6;
                  letter-spacing: 0;
                  line-height: 14px;
                  text-decoration: underline;
                  margin-right: 18px;
                  display: none;
                  cursor: pointer;
                }
                .messageTime {
                  float: right;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #c8c7cc;
                  letter-spacing: 0;
                  line-height: 14px;
                }
              }
            }
          }
          .lisyQun-item:hover .checkContext {
            display: block !important;
          }
        }
      }
    }
    .page-wrapper {
      margin-top: 40px;
    }
  }

  .content-up {
    background-color: #fff;
    width: 944px;
    padding: 30px 0;
    .buttonGroup {
      height: 35px;
      width: 525px;
    }
    .datePicker {
      position: absolute;
      right: 0;
      top: 0;
      width: 200px;
      margin-right: 100px;
    }
  }

  .qun-title span{
    width: 15%;
      margin-left: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 14px;
  }

  .qun-info span {
    width: 15%;
    margin-left: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 14px;
  }

}
</style>
